import {
  Checkbox,
  Grid,
  Group,
  Image,
  Stack,
  Text,
  Tooltip
} from '@mantine/core'
import { ReactNode } from 'react'

type IntegrationListItemProps = {
  checkboxId: string
  isSelected: boolean
  logoSrc?: string
  title: string | ReactNode
  description?: string | ReactNode
  showDetails?: boolean
  contentWidth?: number
  disabled?: boolean
  tooltip?: ReactNode
  children?: ReactNode
  onChange: (value: boolean) => void
}

export const IntegrationListItem = ({
  checkboxId,
  isSelected,
  logoSrc,
  title,
  description,
  showDetails = false,
  contentWidth,
  disabled,
  children,
  tooltip,
  onChange
}: IntegrationListItemProps) => {
  return (
    <Tooltip
      disabled={!tooltip}
      label={tooltip}
      w={320}
      position="top-start"
      multiline
    >
      <Grid
        gutter="lg"
        styles={{
          root: {
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? 'not-allowed' : undefined
          }
        }}
      >
        <Grid.Col span="content">
          <Checkbox
            id={checkboxId}
            checked={isSelected}
            disabled={disabled}
            onChange={(event) => onChange(event.currentTarget.checked)}
          />
        </Grid.Col>

        <Grid.Col span="auto">
          <Stack gap={4} pos="relative" top={-4}>
            <Group align="center" wrap="nowrap" gap="md">
              {logoSrc && <Image src={logoSrc} w={28} h={28} fit="contain" />}

              <label
                htmlFor={checkboxId}
                style={{
                  userSelect: 'none',
                  cursor: disabled ? 'not-allowed' : 'pointer',
                  minWidth: 240
                }}
              >
                <Text size="sm" fw="bold">
                  {title}
                </Text>
              </label>
            </Group>

            <Stack ml={45} maw={contentWidth} gap="xl">
              {description && (
                <Text size="xs" c="dimmed">
                  {description}
                </Text>
              )}

              {showDetails && children && <div>{children}</div>}
            </Stack>
          </Stack>
        </Grid.Col>
      </Grid>
    </Tooltip>
  )
}
